import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Shield } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import '../InnerRefresh.css';

const AboutUsPage = () => {
  const { t, language } = useLanguage();
  const assessmentText = language === 'pl'
    ? 'Analizujemy przekazane informacje i dokumenty, aby ocenić sprawę i zaproponować możliwe dalsze kroki.'
    : 'We review the information and documents you provide to assess your case and propose possible next steps.';
  const principles = ['professionalism', 'individualApproach', 'confidentiality', 'ongoingSupport'];
  return (
    <div className="tb-inner">
      <Header />
      <main>
        <section className="tb-inner-hero tb-container">
          <div className="tb-inner-hero-copy"><h1>{t('nav.aboutUs')}</h1><p className="tb-inner-lead">{t('aboutPage.welcomeText')}</p><Link to="/#consultation-form" className="tb-button">{t('aboutPage.getConsultation')}<ArrowUpRight size={19} aria-hidden="true" /></Link></div>
          <div className="tb-service-symbol" aria-hidden="true"><Shield strokeWidth={1.1} /></div>
        </section>
        <div className="tb-container tb-inner-body">
          <section className="tb-about-editorial tb-inner-section"><h2>{t('aboutPage.teamTitle')}</h2><div className="tb-inner-prose">{[1, 2, 3].map(i => <p key={i}>{t(`aboutPage.teamText${i}`)}</p>)}</div></section>
          <section className="tb-about-editorial tb-inner-section"><h2>{t('aboutPage.resultTitle')}</h2><div className="tb-inner-prose"><p>{assessmentText}</p></div></section>
          <section className="tb-inner-section tb-about-principles"><h2>{t('aboutPage.whyTitle')}</h2><div className="tb-principles-list">{principles.map(key => <div className="tb-principle" key={key}><h3>{t(`aboutPage.${key}`)}</h3><p>{t(`aboutPage.${key}Desc`)}</p></div>)}</div></section>
          <div className="tb-inner-end-action"><Link className="tb-button" to="/#consultation-form">{t('aboutPage.getConsultation')}<ArrowUpRight size={19} aria-hidden="true" /></Link></div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default AboutUsPage;
